import React from 'react';
import { downloadFile } from '../../util/DataHelpers';

interface ExportToCsvProps {
    data?: any[];
    headers: string[];
    fileName?: string;
    getRow?: (row: any) => any[];
    buttonLabel?: string;
    className?: string;
    customHeaderRows?: string[];
    disabled?: boolean;
    onExport?: () => Promise<any[]> | any[];
    groupBy?: (row: any) => string;
    groupHeaderLabel?: string;
}

const ExportToCsv: React.FC<ExportToCsvProps> = ({
    data,
    headers,
    fileName = 'export.csv',
    getRow,
    buttonLabel = 'Export to CSV',
    className = 'btn btn-primary',
    customHeaderRows = [],
    disabled = false,
    onExport,
    groupBy,
    groupHeaderLabel
}) => {
    const exportToCSV = async () => {
        let exportData = data;

        if (onExport) {
            exportData = await onExport();
        }

        if (!exportData.length && !(customHeaderRows && customHeaderRows.length)) return;
        const replacer = (value: any) => value === null || value === undefined ? '' : value;
        const stringify = (v: any) => JSON.stringify(replacer(v));

        const rows: string[] = [];

        if (customHeaderRows && customHeaderRows.length) {
            rows.push(...customHeaderRows);
        }

        if (!groupBy) {
            rows.push(headers.join(','));
            rows.push(
                ...exportData.map(row => {
                    const rowData = getRow ? getRow(row) : headers.map(h => (row as any)[h]);
                    return rowData.map(stringify).join(',');
                })
            );
        } else {
            const groups = new Map<string, any[]>();
            for (const row of exportData) {
                const key = groupBy(row);
                const bucket = groups.get(key) || [];
                bucket.push(row);
                groups.set(key, bucket);
            }

            for (const [name, items] of groups.entries()) {
                rows.push(`"${groupHeaderLabel ?? 'Group'}",${stringify(name)}`);

                rows.push(headers.join(','));

                for (const row of items) {
                    const rowData = getRow ? getRow(row) : headers.map(h => (row as any)[h]);
                    rows.push(rowData.map(stringify).join(','));
                }

                rows.push('');
            }
        }

        const csvString = rows.join('\r\n');
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        downloadFile(blob, fileName);
    };

    return (
        <button onClick={exportToCSV} className={className} disabled={disabled}>{buttonLabel}</button>
    );
};

export default ExportToCsv;
